"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertGoogleMapAPIScript = void 0;
var insertGoogleMapAPIScript = function insertGoogleMapAPIScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = function () {
      return callback();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};
exports.insertGoogleMapAPIScript = insertGoogleMapAPIScript;